import { render, staticRenderFns } from "./BuyNowFeature.vue?vue&type=template&id=24c55130&"
import script from "./BuyNowFeature.vue?vue&type=script&lang=ts&"
export * from "./BuyNowFeature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BuyNowFeature.vue"
export default component.exports